import { computed } from 'vue'
import i18n from '@/plugins/i18n.js'

export function useStatusStyles() {
  const baseClass = 'publishing px-1 d-flex white--text rounded-sm'

  // Make this computed so it reacts to language changes
  const possibleStatus = computed(() => ({
    UPLOADING: {
      css: `${baseClass} uploading`,
      text: i18n.t('shooting.status.uploading')
    },
    AI_PROCESSING: {
      css: `${baseClass} aiProcessing`,
      text: i18n.t('shooting.status.aiProcessing')
    },
    QUALITY_CONTROL: {
      css: `${baseClass} qualityControl`,
      text: i18n.t('shooting.status.qualityControl')
    },
    PUBLISHING: {
      css: `${baseClass} publishing`,
      text: i18n.t('shooting.status.publishing')
    },
    FINISHED: {
      css: `${baseClass} finished`,
      text: i18n.t('shooting.status.finished')
    }
  }))

  const getCssClass = (content) => {
    const status = possibleStatus.value[content]
    return status ? status.css : 'font-weight-bold'
  }

  const getStatusText = (content) => {
    const status = possibleStatus.value[content]
    return status ? status.text : content
  }

  return {
    getCssClass,
    getStatusText
  }
}
